import HttpServices from '@/api/service/HttpServices'

export default class PermissionsHelper {
  static getEmptyCloudWarehouseSettingPromise() {
    return Promise.resolve('0')
  }

  /**
   * 获取隐藏的路由配置信息
   * @param merchantId
   * @param platformId
   */
  static getHiddenPermissionInfo(merchantId, platformId) {
    return new Promise((resolve, reject) => {
      const permissionList = [
        // PermissionsHelper.getCloudWarehouseSettingPromise(merchantId, platformId),
        PermissionsHelper.getEmptyCloudWarehouseSettingPromise(),
        PermissionsHelper.getPayOwnPromise(),
        PermissionsHelper.getMerchantNewFieldPromise(merchantId)
      ]
      Promise.all(permissionList)
        .then(list => {
            let hiddenPermissionList
            let payConfig = list[1]
            if (payConfig.own) {
              // 独立支付版本左侧导航栏隐藏路由项
              hiddenPermissionList = ['BalanceRecharge', 'ExtractMoney', 'CreditPayment', 'DirectPurchase']
            } else {
              hiddenPermissionList = ['WithdrawList']
            }
            if (!payConfig.applets) {
              hiddenPermissionList.push('Applets')
            }
            if (String(list[0]) !== '1') {
              const list = ['YunCang', 'CloudOrders']
              hiddenPermissionList.push(...list)
            }
            let merchantField = {}
            merchantField.merchantType = list[2].merchantType
            merchantField.productCatalogList = list[2].productCatalogList
            if (list[2].productCatalogList && list[2].productCatalogList.length) {
              if (!list[2].productCatalogList.some(item => item == 5)) {
                const list = ['ConsolidationServices']
                hiddenPermissionList.push(...list)
              }
              if (list[2].productCatalogList && list[2].productCatalogList.length === 1 && list[2].productCatalogList.some(item => item == 5)) {
                const list = ['DestinationList']
                hiddenPermissionList.push(...list)
              }
              if (!list[2].productCatalogList.some(item => item == 8)) {
                const list = ['CouponCodeList', 'CouponOrderList', 'CouponProductList']
                hiddenPermissionList.push(...list)
              }
              if (!list[2].productCatalogList.some(item => item == 8 || item == 5)) {
                const list = ['Consignment', 'LogisticsUsageRecord', 'LogisticsPurchasing']
                hiddenPermissionList.push(...list)
              }
            }
            resolve({
              hiddenPermissionList: hiddenPermissionList,
              ...list[1],
              merchantField: merchantField
            })
          }
        )
        .catch(reason => reject(reason))
    })

  }

  static getPayOwnPromise() {
    return HttpServices.getUserService().post('api/v2/paySetUp/query/own', {})
  }

  static getCloudWarehouseSettingPromise(merchantId, platformId) {
    const params = { merchantId, platformId }
    return HttpServices.getServerApiService().post('domain/setting/queryMerchantCloudState', params)
  }

  static getMerchantNewFieldPromise(merchantId) {
    return HttpServices.getUserService().post('api/v2/merchant/getMerchantNewField/' + merchantId, {})
  }
}